<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="文件管理" name="file">
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button type="primary" @click="handleAddFile">添加文件</el-button>
          </el-col>
        </el-row>
        <el-table v-loading="loading" :data="dataList" >
          <el-table-column label="文件名称" min-width="150" align="center" prop="fileName" />
          <el-table-column label="大小" min-width="100" align="center" prop="fileSizeStr" />
          <el-table-column label="文件夹" min-width="100" align="center" prop="folderName" />
          <el-table-column label="描述" min-width="100" align="center" prop="description">
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                width="400"
                trigger="hover"
                :content="scope.row.description">
                <span class="over-text" slot="reference">{{scope.row.description}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="170" align="center" prop="createTime" />
          <el-table-column label="操作" min-width="130" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleSee(scope.row)">查看</el-button>
              <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="queryFileList"
        />
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
          </el-col>
        </el-row>

      </el-tab-pane>


      <el-tab-pane label="文件夹管理" name="folder">
        <el-row :gutter="30" class="mb8">
          <el-col :span="1.5">
            <el-button type="primary" @click="handleAddFolder">添加文件夹</el-button>
          </el-col>
        </el-row>
        <el-table v-loading="loading" :data="folderDataList" >
          <el-table-column label="文件夹名称" min-width="150" align="center" prop="folderName" />
          <el-table-column label="创建时间" min-width="170" align="center" prop="createTime" />
          <el-table-column label="操作" min-width="130" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="folderHandleEdit(scope.row)">编辑</el-button>
              <el-button type="text" @click="folderHandleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
                <pagination
                  v-show="folderTotal>0"
                  :total="folderTotal"
                  :page.sync="folderQueryParams.pageNum"
                  :limit.sync="folderQueryParams.pageSize"
                  @pagination="queryFolderList"
                />
        <el-row :gutter="10" class="mb8">
        </el-row>

      </el-tab-pane>

    </el-tabs>
    <AddFile ref="addFileDialog" @success="getList"></AddFile>
    <AddFolder ref="addFolderDialog" @success="getFolderList"></AddFolder>
  </div>
</template>

<script>
import { queryFileList, deleteFile,queryFolderList,deleteFolder} from "@/api/saas/package";
import { amountFormat } from "@/utils/index";
import AddFile from "./components/addFileDialog";
import AddFolder from "./components/addFolderDialog";
import {deleteFolderCheck} from "../../../../api/saas/package";

export default {
  name: "BusinessList",
  props: {
    customerId: {},
    contactId: {},
    height: {
      type: String,
      default() {
        return "250";
      }
    }
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      dataList: [
        {
          name: "一体化设备",
          size: "20M",
          folder: "产品册",
          desc: "说明文字",
          updateTime: "2021.03.01 12:12:12"
        }
      ],
      folderTotal:0,
      folderQueryParams: {
        pageNum: 1,
        pageSize: 10
      },
      folderDataList:[
        {
          name: "文件夹一号",
          createTime: "2021.03.01 12:12:12"
        }
      ],
      amountFormat,
      activeName: 'file',
      checkPass:false,
      folderRowData:{}
    };
  },
  created() {
    this.queryFileList();
    this.queryFolderList();
  },
  components: {
    AddFile,
    AddFolder
  },
  methods: {
    handleAddFolder() {
      this.$refs.addFolderDialog.open();
    },
    handleAddFile() {
      this.$refs.addFileDialog.open();
    },
    getList() {
      this.queryParams.pageNum = 1
      this.queryFileList()
    },
    getFolderList() {
      console.log("新增成功，调用回调，刷新列表")
      this.folderQueryParams.pageNum = 1
      this.queryFolderList()
    },
    queryFileList() {
      this.loading = true;
      queryFileList(this.queryParams)
        .then(response => {
          this.dataList = response.rows;
          this.loading = false;
          this.total = response.total
        })
        .catch(error => {
          this.loading = false;
        });
    },
    queryFolderList() {
      this.loading = true;
      queryFolderList(this.folderQueryParams)
        .then(response => {
          this.folderDataList = response.rows;
          this.loading = false;
          this.folderTotal = response.total
        })
        .catch(error => {
          this.loading = false;
        });
    },
    handleSee(row) {
        this.$refs.addFileDialog.open(row, 'see');
    },
    handleEdit(row) {
        this.$refs.addFileDialog.open(JSON.parse(JSON.stringify(row)), 'edit');
    },
    handleDelete(row) {
      const that = this
      this.$confirm('确认删除该文件吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deleteFile(row)
      })
    },
    deleteFile(row) {
      deleteFile({
        fileId: row.fileId
      })
        .then(response => {
          this.msgSuccess('删除成功！')
          this.queryFileList()
        })
        .catch(error => {
          this.loading = false;
        });
    },
    /** 详细按钮操作 */
    toDetail(row) {
      this.$router.push("/crm/business/detail/" + row.id);
    },
    folderHandleEdit(row) {
      this.$refs.addFolderDialog.open(JSON.parse(JSON.stringify(row)), 'edit');
    },
    folderHandleDelete(row) {
      //删除前检测文件夹下面是否有文件
      this.folderRowData=row;
      deleteFolderCheck({
        folderId: row.folderId
      }) .then(response => {
        this.folderHandleDeleteCheckPass(this.folderRowData);
      }).catch(error => {
        this.loading = false;
      });
    },
    folderHandleDeleteCheckPass(row) {
      const that = this
      this.$confirm('请确认是否删除文件夹', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deleteFolder(row)
      });
    },
    deleteFolder(row) {

      deleteFolder({
        folderId: row.folderId
      })
        .then(response => {
          this.msgSuccess('删除成功！')
          this.queryFolderList()
        })
        .catch(error => {
          this.loading = false;
        });


    },
  }
};
</script>
<style lang="scss" scoped>
.over-text {
  max-width: 200px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
